export enum UmbracoErrorType {
	Generic = 'generic',
	NotFound = 'notfound',
	Forbidden = 'forbidden',
	Unauthorized = 'unauthorized'
}
